import FuseCarousel from '@tvg/fuse-design/carousel';
import React from 'react';
import { type RecProduct } from 'server/services/recommendation';
import CarouselProductCard from './CarouselProductCard';

interface CarouselProps {
  products?: RecProduct[];
  'data-testid': string;
  [key: string]: any;
}

const ProductSkeletons = new Array(6).fill(null);

function CarouselSkeleton({
  'data-testid': dataTestId,
  ...props
}: CarouselProps) {
  return (
    <FuseCarousel
      title=" " // to reduce layout shift
      {...props}
      data-carousel-type="skeleton"
      dataTestId={dataTestId}
    >
      {ProductSkeletons.map((_, idx) => (
        <CarouselProductCard
          key={idx}
          isSkeleton
          data-testid="product-card-skeleton"
        />
      ))}
    </FuseCarousel>
  );
}

export default React.memo(CarouselSkeleton);
